import { Injectable } from '@angular/core';

import {ParagraphSmallColumnModuleData, MultipleColumnItemDataInner, ParagraphMultipleColumnData, ParagraphMultipleColumnItemData } from '@generated/content';
import {
  FileFileData,
  MediaAudioData,
  MediaImageData,
  MediaRemoteVideoData,
  MediaVideoData,
  ParagraphTextMediaBoxData,
} from '@generated/content';
import { TMediaNodeType } from '@interfaces/media';
import { YoutubeVideo } from '@models/classes';
import { CmsComponentNodeData } from '@interfaces/cms-component-node-data';
import { SmallColumnModule } from '@interfaces/config/cms-components/small-column-module-config';
import { inject } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';
import { CustomApiService } from '@services/api/custom-api';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injector } from '@angular/core';
import { ButtonTypeEnum, CmsComponentTypeEnum, CmsMediaTypeEnum, MediaTypesEnum } from '@models/enums';
import { CmsComponentConfig, TextMediaBox } from '@interfaces/config';
import { CmsFixes } from '@interfaces/_fixes';
import { MediaResolver } from '@services/resolvers/auxiliary/media-resolver';
import { EloquaService } from '@services/eloqua/eloqua.service';
import { EloquaApi } from '@lib/apis/eloqua-api';
@Injectable({ providedIn: 'root' })
export class SmallColumnModuleComponentResolver extends BaseComponentResolver {
  static override instance: SmallColumnModuleComponentResolver;
  private readonly componentType = SmallColumnModule.TypeEnum;

 public customApiService:EloquaService;

  constructor() {
    super();

    const injector = Injector.create({
      providers: [
       
        { provide: EloquaService, deps: [] }
      ]
    });
    this.customApiService = injector.get(EloquaService);
   
  }


  static getInstance(): SmallColumnModuleComponentResolver {
 
    return (SmallColumnModuleComponentResolver.instance ||= new SmallColumnModuleComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphSmallColumnModuleData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<SmallColumnModule.ComponentConfig> | null {
    if (!node) {
      return null;
    }

  

    this.nodePageData = nodePageData;
    

     

   return {
      componentType: this.componentType,
      config: {
        nodeId: BaseComponentResolver.getNodeId(node),
        columns: this.getColumns(node),
        field_headline : this.getFieldHeadLine(node),
        title:  this.getFieldHeadLine(node),
        
      },
    };


    
  }

  
  private getFieldHeadLine(node: ParagraphSmallColumnModuleData):string{
    if(!node)
    return null;
  return node.attributes?.field_headline?.value;
  }

  private getFieldAlignment(node: ParagraphSmallColumnModuleData):string{
  
    return null;
  }
  private getColumns(node: ParagraphSmallColumnModuleData):  TextMediaBox.ComponentConfig[] {



    if (!node.relationships.field_module?.data?.length) {
      return [];
    }


     return node.relationships.field_module.data.map(item => this.buildColumnConfig(item));
  }


  private buildColumnConfig(node: any): TextMediaBox.ComponentConfig | null {
    const { id, type } = node;
  
    if (!(id && node)) {
      return null;
    }
    const selectedLanguage ="en";
 
    const columnNode = this.getNode<ParagraphTextMediaBoxData>(id, type);

    if (!columnNode) {
      return null;
    }

 
     const cta = this.buildCtaObject(columnNode);
     const media = this.getMediaConfig(columnNode);
     const mediaLink = this.getMediaConfigCta(columnNode);
     const mediaSize = columnNode.attributes.field_media_size_mediabox === 'large' ? 'large' : 'small';
    const order = this.getOrder(columnNode);
    const layout = this.getLayout(columnNode);
    
     const [title, headline, body] = this.buildTexts(columnNode);
     const background = this.getBackground(columnNode);

   //console.log("colnode",columnNode)

    return  {
      
        nodeId:  columnNode.id,
        title,
        headline,
        body,
        media,
        mediaLink,
        mediaSize,
        cta,
        order,
        layout,
        background,
      
    };


  }

    private buildCtaObject(node: ParagraphTextMediaBoxData): {
      label: string;
      url: string;
      buttonType: ButtonTypeEnum;
      target: '_self' | '_blank';
    } {

    

      if (!node?.attributes.field_cta_link_mediabox) {
        return null;
      }
  
      const label = this.hyphenate(node.attributes.field_cta_link_mediabox.title);
      const url = node.attributes.field_cta_link_mediabox.url;
      const buttonType = this.getButtonType(node);
      const target = node.attributes.field_openinnewtab === true ? '_blank' : '_self';
  
      return { label, url, buttonType, target };
    }


      private getBackground(node: ParagraphTextMediaBoxData): boolean {
        const setting = node.attributes?.field_gray_layer ?? 'true';
    
        return setting === 'true';
      }

      private getMediaConfigCta(node: ParagraphTextMediaBoxData): {
        label: string;
        url: string;
     
      } {

        if (!node?.attributes.field_media_link) {
          return null;
        }
   
        const label = this.hyphenate(node.attributes.field_media_link.title);
        const url = node.attributes.field_media_link.url;
     
     
    
        return { label, url };
      }
    
      private getMediaConfig(
        node: ParagraphTextMediaBoxData
      ):
        | TextMediaBox.MediaImageConfig
        | TextMediaBox.MediaYoutubeVideoConfig
        | TextMediaBox.MediaVideoConfig
        | TextMediaBox.MediaAudioConfig {
        if (!node?.relationships?.field_media_mediabox?.data) {
          return null;
        }
    
        
        const { type, id } = node.relationships.field_media_mediabox.data;
    
        

        switch (type) {
          case MediaImageData.TypeEnum.MediaImage:
            const { dataUrls, metas } = this.getMediaDataUrls(id, type as TMediaNodeType, null, true);
            return {
              type: MediaTypesEnum.IMAGE,
              dataUrls,
              metas,
              fill: true,
              sizes: MediaResolver.buildImageConfigSizes(CmsComponentTypeEnum.TEXT_MEDIA_BOX),
            };
    
          case CmsMediaTypeEnum.RemoteVideo:
            const remoteVideoNode = this.getNode<MediaRemoteVideoData>(id, type);
            return new YoutubeVideo(remoteVideoNode).getComponentConfig();
    
          case CmsMediaTypeEnum.Video:
            return this.getMediaVideoConfig(id);
    
          case CmsMediaTypeEnum.Audio:
            return this.getMediaAudioConfig(id);
    
          default:
            return null;
        }
      }
    
      private getMediaVideoConfig(id: string): TextMediaBox.MediaVideoConfig {
        const mediaVideoNode = this.getNode<MediaVideoData>(id, CmsMediaTypeEnum.Video);
    
        const thumbnailNode = this.getNode<FileFileData>(
          mediaVideoNode?.relationships?.thumbnail?.data?.id,
          FileFileData.TypeEnum.FileFile
        );
    
        let thumbnail: string = null;
    
        if (thumbnailNode?.attributes?.image_style_uri) {
          thumbnail =
            thumbnailNode.attributes.image_style_uri['webp'] || thumbnailNode.attributes.image_style_uri['thumbnail'] || null;
        }
    
        const fileNode = this.getNode<FileFileData>(
          mediaVideoNode?.relationships?.field_media_video_file?.data?.id,
          FileFileData.TypeEnum.FileFile
        );
    
        if (!fileNode?.attributes?.uri?.url) {
          return null;
        }
    
        return {
          type: MediaTypesEnum.VIDEO,
          url: fileNode.attributes.uri.url,
          caption: null,
          metas: null,
          thumbnail,
        };
      }
    
      private getMediaAudioConfig(id: string): TextMediaBox.MediaAudioConfig {
        const mediaAudioNode = this.getNode<MediaAudioData>(id, CmsMediaTypeEnum.Audio);
        const fileNodeId = mediaAudioNode?.relationships?.field_media_audio_file?.data?.id;
    
        if (!fileNodeId) {
          return null;
        }
    
        const fileNode = this.getNode<FileFileData>(
          mediaAudioNode?.relationships?.field_media_audio_file?.data?.id,
          FileFileData.TypeEnum.FileFile
        );
    
        return {
          type: MediaTypesEnum.AUDIO,
          url: fileNode?.attributes?.uri?.url ?? null,
          fileNodeId,
          metas: {
            title: mediaAudioNode.attributes.field_title ?? 'Podcast',
            description: mediaAudioNode.attributes.field_description ?? null,
          },
        };
      }


      private getOrder(node: ParagraphTextMediaBoxData): TextMediaBox.Order | null {
        if (!node?.attributes.field_media_posistion_mediabox) {
          return null;
        }
    
        return node.attributes.field_media_posistion_mediabox === 'left'
          ? TextMediaBox.Order.MEDIA_TEXT
          : TextMediaBox.Order.TEXT_MEDIA;
      }

      private getLayout(node: ParagraphTextMediaBoxData): TextMediaBox.Layout {
        if (!node.attributes.field_layout) {
          return TextMediaBox.Layout.STANDARD;
        }
    
        switch (node.attributes.field_layout) {
          case 'squared':
            return TextMediaBox.Layout.SQUARED;
          case 'big-image':
            return TextMediaBox.Layout.BIG_IMAGE;
          default:
            return TextMediaBox.Layout.STANDARD;
        }
      }
    
    private buildTexts(node: ParagraphTextMediaBoxData): string[] {
  
      const attributes = node.attributes as CmsFixes.ParagraphTextMediaBoxDataAttributes;
  
      const title = attributes?.field_headline_new_mediabox
        ? attributes?.field_headline_new_mediabox
        : attributes.field_title_mediabox;
  
      return [title, attributes.field_headline_mediabox, attributes.field_sub_headline_mediabox?.processed].map(this.hyphenate);
    }

}
